// extracted by mini-css-extract-plugin
module.exports = {"icon":"_2kv-0a","shine-lines":"_3EFZvP"};